import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AgeLimit from 'components/AgeLimit/AgeLimit';
import PurchaseModal from 'components/PurchaseModal/PurchaseModal';
import CinemaSVG from 'components/CinemaSVG/CinemaSVG';
import LazyLoad from 'react-lazy-load';
import './film-tile.scss';


class FilmTile extends Component {
  state = {
    indexOfCinema: -1,
    isError: false,
  };

  componentDidMount() {
    if (this.props.imgUrl === null) {
      this.setState({
        isError: true,
      });
    }
  }

  render() {
    const {
      hours, minutes, selectedDate,
      title, cinemaList, schedule,
      ageLimit, width, onModalClick,
      activeModal, cannonicalUrl,
      brandClass, imgUrl, brand,
      webpUrl,
    } = this.props;
    const { isError } = this.state;
    return (
      <div
        className={
          width < 1200
            ? 'react-film-tile-container react-tiles-small'
            : `${width ? 'react-film-tile-container react-tiles-big' : 'react-film-tile-container react-tiles-mobile'}`
        }
      >
        <div style={{ overflow: 'hidden' }}>
          <a href={cannonicalUrl} onClick={() => window.location.assign(cannonicalUrl)}>
            <LazyLoad offset={600}>
              <picture>
                <source
                  type="image/webp"
                  srcSet={webpUrl}
                />
                <img
                  className={isError ? 'react-film-tile-pic error' : 'react-film-tile-pic'}
                  src={imgUrl}
                  alt={title}
                  onError={
                    () => this.setState({
                      isError: true,
                    })
                  }
                />
              </picture>
            </LazyLoad>
          </a>
        </div>
        <div>
          <a className="react-film-tile-title" href={cannonicalUrl} onClick={() => window.location.assign(cannonicalUrl)}>
            <span className="react-film-tile-title-item">
              {title}
            </span>
            <span className="react-film-tile-limit-container">
              <AgeLimit age={ageLimit} />
            </span>
          </a>
        </div>
        <div className="react-film-tile-premier">{schedule[0].cinemas[0].premiere}</div>
        {
          brand === 0 || cinemaList.length > 1
            ? (
              <React.Fragment>
                <div className={brandClass && brandClass !== 'react-artmozi' ? 'react-none' : 'react-film-tile-movies-title'}>Mozik, amik vetítik:</div>
                <div className={brandClass && brandClass !== 'react-artmozi' ? 'react-none' : 'react-film-tile-movies-list'}>
                  {cinemaList && cinemaList.map(({ icon, name }, index) => (
                    <div
                      key={index.toString()}
                      className="react-film-tile-cinemalist"
                      onMouseEnter={() => this.setState({ indexOfCinema: index })}
                      onMouseLeave={() => this.setState({ indexOfCinema: -1 })}
                    >
                      <div className={index === this.state.indexOfCinema ? 'react-popup-wrapper' : 'react-none'}>
                        <span className="react-popup-cinema-icon"><CinemaSVG cinema={icon} /></span>
                        <span className="react-popup-cinema-name">{name}</span>
                      </div>
                      <CinemaSVG cinema={icon} />
                    </div>
                  ))}
                </div>
              </React.Fragment>
            )
            : null
        }
        <div className={width ? 'react-film-tile-schedule-container' : 'react-film-tile-schedule-container react-mobile'}>
          {
            schedule && schedule.map((date, index) => (
              <PurchaseModal
                {...date}
                width={width}
                maxWidth="100px"
                color="#000"
                bColor="#FFF"
                tabIndex={index.toString()}
                handleClick={() => onModalClick({
                  title,
                  playtime: date.playtime,
                })}
                active={activeModal.title === title && activeModal.playtime === date.playtime}
                rows={Math.floor(schedule.length / 4) + 1}
                hours={hours}
                minutes={minutes}
                selectedDate={selectedDate}
                brandClass={brandClass}
                key={`${schedule.playtime} ${index.toString()}`}
              />
            ))
          }
        </div>
      </div>
    );
  }
}


FilmTile.propTypes = {
  hours: PropTypes.number,
  brandClass: PropTypes.string,
  minutes: PropTypes.number,
  selectedDate: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  width: PropTypes.number,
  activeModal: PropTypes.shape({}).isRequired,
  imgUrl: PropTypes.string.isRequired,
  webpUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onModalClick: PropTypes.func.isRequired,
  ageLimit: PropTypes.string,
  cannonicalUrl: PropTypes.string.isRequired,
  cinemaList: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.string,
    ]),
  ).isRequired,
  schedule: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  brand: PropTypes.number.isRequired,
};

FilmTile.defaultProps = {
  ageLimit: null,
  hours: new Date().getHours(),
  minutes: new Date().getMinutes(),
  selectedDate: null,
  width: undefined,
  brandClass: 'react-artmozi',
};

export default FilmTile;
